import {
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  StringSerializer_getInstance100dxy5jlaaom as StringSerializer_getInstance,
  FloatSerializer_getInstance3n1kixy3l1peh as FloatSerializer_getInstance,
  IntSerializer_getInstance3jjhuzya8j8kz as IntSerializer_getInstance,
  SealedClassSerializeriwipiibk55zc as SealedClassSerializer,
  BooleanSerializer_getInstance1a8uvzxl1s4k4 as BooleanSerializer_getInstance,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID7hggqo3abtya as VOID,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  Unit_instanceat14thlj150z as Unit_instance,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  createThis2j2avj17cvnv2 as createThis,
  getKClass1s3j9wy1cofik as getKClass,
  LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  isInterface3d6p8outrmvmk as isInterface,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  emptyList1g2z5xcrvp2zy as emptyList,
} from './kotlin-kotlin-stdlib.mjs';
import { ProtoNumber3ejuegvjqu86s as ProtoNumber } from './kotlinx-serialization-kotlinx-serialization-protobuf.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.id9_1 = [new ArrayListSerializer($serializer_getInstance_0())];
  }
}
class $serializer {
  constructor() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GameState', this, 1);
    tmp0_serialDesc.rd0('players', false);
    tmp0_serialDesc.sd0(new ProtoNumber(1));
    this.jd9_1 = tmp0_serialDesc;
  }
  kd9(encoder, value) {
    var tmp0_desc = this.jd9_1;
    var tmp1_output = encoder.gcx(tmp0_desc);
    var tmp2_cached = Companion_getInstance().id9_1;
    tmp1_output.pcx(tmp0_desc, 0, tmp2_cached[0], value.ld9_1);
    tmp1_output.qcw(tmp0_desc);
  }
  uct(encoder, value) {
    return this.kd9(encoder, value instanceof GameState ? value : THROW_CCE());
  }
  vct(decoder) {
    var tmp0_desc = this.jd9_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.gcx(tmp0_desc);
    var tmp6_cached = Companion_getInstance().id9_1;
    if (tmp5_input.rcw()) {
      tmp4_local0 = tmp5_input.zcw(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.scw(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.zcw(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.jcv(tmp2_index);
        }
      }
    tmp5_input.qcw(tmp0_desc);
    return GameState.md9(tmp3_bitMask0, tmp4_local0, null);
  }
  tct() {
    return this.jd9_1;
  }
  od0() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance().id9_1[0]];
  }
}
class ServerPacket {
  static nd9(seen0, serializationConstructorMarker) {
    Companion_getInstance_4();
    return createThis(this);
  }
}
class GameState extends ServerPacket {
  toString() {
    return 'GameState(players=' + toString(this.ld9_1) + ')';
  }
  hashCode() {
    return hashCode(this.ld9_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameState))
      return false;
    var tmp0_other_with_cast = other instanceof GameState ? other : THROW_CCE();
    if (!equals(this.ld9_1, tmp0_other_with_cast.ld9_1))
      return false;
    return true;
  }
  static md9(seen0, players, serializationConstructorMarker) {
    Companion_getInstance();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance().jd9_1);
    }
    var $this = this.nd9(seen0, serializationConstructorMarker);
    $this.ld9_1 = players;
    return $this;
  }
}
class Companion_0 {}
class $serializer_0 {
  constructor() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.samples.clientserver.PlayerState', this, 5);
    tmp0_serialDesc.rd0('id', false);
    tmp0_serialDesc.sd0(new ProtoNumber(1));
    tmp0_serialDesc.rd0('x', false);
    tmp0_serialDesc.sd0(new ProtoNumber(2));
    tmp0_serialDesc.rd0('y', false);
    tmp0_serialDesc.sd0(new ProtoNumber(3));
    tmp0_serialDesc.rd0('lastProcessedSequenceId', false);
    tmp0_serialDesc.sd0(new ProtoNumber(4));
    tmp0_serialDesc.rd0('username', true);
    tmp0_serialDesc.sd0(new ProtoNumber(5));
    this.od9_1 = tmp0_serialDesc;
  }
  pd9(encoder, value) {
    var tmp0_desc = this.od9_1;
    var tmp1_output = encoder.gcx(tmp0_desc);
    tmp1_output.ocx(tmp0_desc, 0, value.qd9_1);
    tmp1_output.ncx(tmp0_desc, 1, value.rd9_1);
    tmp1_output.ncx(tmp0_desc, 2, value.sd9_1);
    tmp1_output.mcx(tmp0_desc, 3, value.td9_1);
    if (tmp1_output.jcx(tmp0_desc, 4) ? true : !(value.ud9_1 === '')) {
      tmp1_output.ocx(tmp0_desc, 4, value.ud9_1);
    }
    tmp1_output.qcw(tmp0_desc);
  }
  uct(encoder, value) {
    return this.pd9(encoder, value instanceof PlayerState ? value : THROW_CCE());
  }
  vct(decoder) {
    var tmp0_desc = this.od9_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = 0;
    var tmp8_local4 = null;
    var tmp9_input = decoder.gcx(tmp0_desc);
    if (tmp9_input.rcw()) {
      tmp4_local0 = tmp9_input.ycw(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.xcw(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.xcw(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.wcw(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.ycw(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.scw(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.ycw(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.xcw(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.xcw(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.wcw(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.ycw(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.jcv(tmp2_index);
        }
      }
    tmp9_input.qcw(tmp0_desc);
    return PlayerState.vd9(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  tct() {
    return this.od9_1;
  }
  od0() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance()];
  }
}
class PlayerState {
  toString() {
    return 'PlayerState(id=' + this.qd9_1 + ', x=' + this.rd9_1 + ', y=' + this.sd9_1 + ', lastProcessedSequenceId=' + this.td9_1 + ', username=' + this.ud9_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.qd9_1);
    result = imul(result, 31) + getNumberHashCode(this.rd9_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.sd9_1) | 0;
    result = imul(result, 31) + this.td9_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.ud9_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlayerState))
      return false;
    var tmp0_other_with_cast = other instanceof PlayerState ? other : THROW_CCE();
    if (!(this.qd9_1 === tmp0_other_with_cast.qd9_1))
      return false;
    if (!equals(this.rd9_1, tmp0_other_with_cast.rd9_1))
      return false;
    if (!equals(this.sd9_1, tmp0_other_with_cast.sd9_1))
      return false;
    if (!(this.td9_1 === tmp0_other_with_cast.td9_1))
      return false;
    if (!(this.ud9_1 === tmp0_other_with_cast.ud9_1))
      return false;
    return true;
  }
  static vd9(seen0, id, x, y, lastProcessedSequenceId, username, serializationConstructorMarker) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_0().od9_1);
    }
    var $this = createThis(this);
    $this.qd9_1 = id;
    $this.rd9_1 = x;
    $this.sd9_1 = y;
    $this.td9_1 = lastProcessedSequenceId;
    if (0 === (seen0 & 16))
      $this.ud9_1 = '';
    else
      $this.ud9_1 = username;
    return $this;
  }
}
class Companion_1 {}
class $serializer_1 {
  constructor() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MapChunkUpdatePacket', this, 2);
    tmp0_serialDesc.rd0('layerName', false);
    tmp0_serialDesc.sd0(new ProtoNumber(1));
    tmp0_serialDesc.rd0('chunk', false);
    tmp0_serialDesc.sd0(new ProtoNumber(2));
    this.wd9_1 = tmp0_serialDesc;
  }
  xd9(encoder, value) {
    var tmp0_desc = this.wd9_1;
    var tmp1_output = encoder.gcx(tmp0_desc);
    tmp1_output.ocx(tmp0_desc, 0, value.yd9_1);
    tmp1_output.pcx(tmp0_desc, 1, $serializer_getInstance_13(), value.zd9_1);
    tmp1_output.qcw(tmp0_desc);
  }
  uct(encoder, value) {
    return this.xd9(encoder, value instanceof MapChunkUpdatePacket ? value : THROW_CCE());
  }
  vct(decoder) {
    var tmp0_desc = this.wd9_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.gcx(tmp0_desc);
    if (tmp6_input.rcw()) {
      tmp4_local0 = tmp6_input.ycw(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.zcw(tmp0_desc, 1, $serializer_getInstance_13(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.scw(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.ycw(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.zcw(tmp0_desc, 1, $serializer_getInstance_13(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.jcv(tmp2_index);
        }
      }
    tmp6_input.qcw(tmp0_desc);
    return MapChunkUpdatePacket.ada(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  tct() {
    return this.wd9_1;
  }
  od0() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), $serializer_getInstance_13()];
  }
}
class MapChunkUpdatePacket extends ServerPacket {
  toString() {
    return 'MapChunkUpdatePacket(layerName=' + this.yd9_1 + ', chunk=' + this.zd9_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.yd9_1);
    result = imul(result, 31) + this.zd9_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MapChunkUpdatePacket))
      return false;
    var tmp0_other_with_cast = other instanceof MapChunkUpdatePacket ? other : THROW_CCE();
    if (!(this.yd9_1 === tmp0_other_with_cast.yd9_1))
      return false;
    if (!this.zd9_1.equals(tmp0_other_with_cast.zd9_1))
      return false;
    return true;
  }
  static ada(seen0, layerName, chunk, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_1().wd9_1);
    }
    var $this = this.nd9(seen0, serializationConstructorMarker);
    $this.yd9_1 = layerName;
    $this.zd9_1 = chunk;
    return $this;
  }
}
class Companion_2 {}
class $serializer_2 {
  constructor() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MapDataPacket', this, 1);
    tmp0_serialDesc.rd0('map', false);
    tmp0_serialDesc.sd0(new ProtoNumber(1));
    this.bda_1 = tmp0_serialDesc;
  }
  cda(encoder, value) {
    var tmp0_desc = this.bda_1;
    var tmp1_output = encoder.gcx(tmp0_desc);
    tmp1_output.pcx(tmp0_desc, 0, $serializer_getInstance_14(), value.dda_1);
    tmp1_output.qcw(tmp0_desc);
  }
  uct(encoder, value) {
    return this.cda(encoder, value instanceof MapDataPacket ? value : THROW_CCE());
  }
  vct(decoder) {
    var tmp0_desc = this.bda_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.gcx(tmp0_desc);
    if (tmp5_input.rcw()) {
      tmp4_local0 = tmp5_input.zcw(tmp0_desc, 0, $serializer_getInstance_14(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.scw(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.zcw(tmp0_desc, 0, $serializer_getInstance_14(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.jcv(tmp2_index);
        }
      }
    tmp5_input.qcw(tmp0_desc);
    return MapDataPacket.eda(tmp3_bitMask0, tmp4_local0, null);
  }
  tct() {
    return this.bda_1;
  }
  od0() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_14()];
  }
}
class MapDataPacket extends ServerPacket {
  toString() {
    return 'MapDataPacket(map=' + this.dda_1.toString() + ')';
  }
  hashCode() {
    return this.dda_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MapDataPacket))
      return false;
    var tmp0_other_with_cast = other instanceof MapDataPacket ? other : THROW_CCE();
    if (!this.dda_1.equals(tmp0_other_with_cast.dda_1))
      return false;
    return true;
  }
  static eda(seen0, map, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_2().bda_1);
    }
    var $this = this.nd9(seen0, serializationConstructorMarker);
    $this.dda_1 = map;
    return $this;
  }
}
class Companion_3 {}
class $serializer_3 {
  constructor() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlayerData', this, 2);
    tmp0_serialDesc.rd0('id', false);
    tmp0_serialDesc.sd0(new ProtoNumber(1));
    tmp0_serialDesc.rd0('username', true);
    tmp0_serialDesc.sd0(new ProtoNumber(2));
    this.fda_1 = tmp0_serialDesc;
  }
  gda(encoder, value) {
    var tmp0_desc = this.fda_1;
    var tmp1_output = encoder.gcx(tmp0_desc);
    tmp1_output.ocx(tmp0_desc, 0, value.hda_1);
    if (tmp1_output.jcx(tmp0_desc, 1) ? true : !(value.ida_1 === '')) {
      tmp1_output.ocx(tmp0_desc, 1, value.ida_1);
    }
    tmp1_output.qcw(tmp0_desc);
  }
  uct(encoder, value) {
    return this.gda(encoder, value instanceof PlayerData ? value : THROW_CCE());
  }
  vct(decoder) {
    var tmp0_desc = this.fda_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.gcx(tmp0_desc);
    if (tmp6_input.rcw()) {
      tmp4_local0 = tmp6_input.ycw(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.ycw(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.scw(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.ycw(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.ycw(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.jcv(tmp2_index);
        }
      }
    tmp6_input.qcw(tmp0_desc);
    return PlayerData.jda(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  tct() {
    return this.fda_1;
  }
  od0() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  }
}
class PlayerData extends ServerPacket {
  toString() {
    return 'PlayerData(id=' + this.hda_1 + ', username=' + this.ida_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.hda_1);
    result = imul(result, 31) + getStringHashCode(this.ida_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlayerData))
      return false;
    var tmp0_other_with_cast = other instanceof PlayerData ? other : THROW_CCE();
    if (!(this.hda_1 === tmp0_other_with_cast.hda_1))
      return false;
    if (!(this.ida_1 === tmp0_other_with_cast.ida_1))
      return false;
    return true;
  }
  static jda(seen0, id, username, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_3().fda_1);
    }
    var $this = this.nd9(seen0, serializationConstructorMarker);
    $this.hda_1 = id;
    if (0 === (seen0 & 2))
      $this.ida_1 = '';
    else
      $this.ida_1 = username;
    return $this;
  }
}
class Companion_4 {
  constructor() {
    Companion_instance_4 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.kda_1 = lazy(tmp_0, ServerPacket$Companion$_anonymous__g5b1ss);
  }
  lda() {
    return _get_$cachedSerializer__te6jhj(this);
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_5 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.mda_1 = lazy(tmp_0, ClientPacket$Companion$_anonymous__1ag50k);
  }
  lda() {
    return _get_$cachedSerializer__te6jhj_0(this);
  }
}
class ClientPacket {
  constructor() {
    Companion_getInstance_5();
  }
  static nda(seen0, serializationConstructorMarker) {
    Companion_getInstance_5();
    return createThis(this);
  }
}
class Companion_6 {}
class $serializer_4 {
  constructor() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.samples.clientserver.MovePacket', this, 3);
    tmp0_serialDesc.rd0('sequenceId', false);
    tmp0_serialDesc.sd0(new ProtoNumber(1));
    tmp0_serialDesc.rd0('dx', false);
    tmp0_serialDesc.sd0(new ProtoNumber(2));
    tmp0_serialDesc.rd0('dy', false);
    tmp0_serialDesc.sd0(new ProtoNumber(3));
    this.oda_1 = tmp0_serialDesc;
  }
  pda(encoder, value) {
    var tmp0_desc = this.oda_1;
    var tmp1_output = encoder.gcx(tmp0_desc);
    tmp1_output.mcx(tmp0_desc, 0, value.qda_1);
    tmp1_output.ncx(tmp0_desc, 1, value.rda_1);
    tmp1_output.ncx(tmp0_desc, 2, value.sda_1);
    tmp1_output.qcw(tmp0_desc);
  }
  uct(encoder, value) {
    return this.pda(encoder, value instanceof MovePacket ? value : THROW_CCE());
  }
  vct(decoder) {
    var tmp0_desc = this.oda_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp7_input = decoder.gcx(tmp0_desc);
    if (tmp7_input.rcw()) {
      tmp4_local0 = tmp7_input.wcw(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.xcw(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.xcw(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.scw(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.wcw(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.xcw(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.xcw(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.jcv(tmp2_index);
        }
      }
    tmp7_input.qcw(tmp0_desc);
    return MovePacket.tda(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  tct() {
    return this.oda_1;
  }
  od0() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance()];
  }
}
class MovePacket extends ClientPacket {
  constructor(sequenceId, dx, dy) {
    super();
    this.qda_1 = sequenceId;
    this.rda_1 = dx;
    this.sda_1 = dy;
  }
  toString() {
    return 'MovePacket(sequenceId=' + this.qda_1 + ', dx=' + this.rda_1 + ', dy=' + this.sda_1 + ')';
  }
  hashCode() {
    var result = this.qda_1;
    result = imul(result, 31) + getNumberHashCode(this.rda_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.sda_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MovePacket))
      return false;
    var tmp0_other_with_cast = other instanceof MovePacket ? other : THROW_CCE();
    if (!(this.qda_1 === tmp0_other_with_cast.qda_1))
      return false;
    if (!equals(this.rda_1, tmp0_other_with_cast.rda_1))
      return false;
    if (!equals(this.sda_1, tmp0_other_with_cast.sda_1))
      return false;
    return true;
  }
  static tda(seen0, sequenceId, dx, dy, serializationConstructorMarker) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_4().oda_1);
    }
    var $this = this.nda(seen0, serializationConstructorMarker);
    $this.qda_1 = sequenceId;
    $this.rda_1 = dx;
    $this.sda_1 = dy;
    return $this;
  }
}
class Companion_7 {}
class $serializer_5 {
  constructor() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AuthHandshakeResponse', this, 3);
    tmp0_serialDesc.rd0('status', false);
    tmp0_serialDesc.sd0(new ProtoNumber(1));
    tmp0_serialDesc.rd0('username', true);
    tmp0_serialDesc.sd0(new ProtoNumber(2));
    tmp0_serialDesc.rd0('playerId', true);
    tmp0_serialDesc.sd0(new ProtoNumber(3));
    this.uda_1 = tmp0_serialDesc;
  }
  vda(encoder, value) {
    var tmp0_desc = this.uda_1;
    var tmp1_output = encoder.gcx(tmp0_desc);
    tmp1_output.mcx(tmp0_desc, 0, value.wda_1);
    if (tmp1_output.jcx(tmp0_desc, 1) ? true : !(value.xda_1 === '')) {
      tmp1_output.ocx(tmp0_desc, 1, value.xda_1);
    }
    if (tmp1_output.jcx(tmp0_desc, 2) ? true : !(value.yda_1 === '')) {
      tmp1_output.ocx(tmp0_desc, 2, value.yda_1);
    }
    tmp1_output.qcw(tmp0_desc);
  }
  uct(encoder, value) {
    return this.vda(encoder, value instanceof AuthHandshakeResponse ? value : THROW_CCE());
  }
  vct(decoder) {
    var tmp0_desc = this.uda_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.gcx(tmp0_desc);
    if (tmp7_input.rcw()) {
      tmp4_local0 = tmp7_input.wcw(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.ycw(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.ycw(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.scw(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.wcw(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.ycw(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.ycw(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.jcv(tmp2_index);
        }
      }
    tmp7_input.qcw(tmp0_desc);
    return AuthHandshakeResponse.zda(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  tct() {
    return this.uda_1;
  }
  od0() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  }
}
class AuthHandshakeResponse extends ServerPacket {
  toString() {
    return 'AuthHandshakeResponse(status=' + this.wda_1 + ', username=' + this.xda_1 + ', playerId=' + this.yda_1 + ')';
  }
  hashCode() {
    var result = this.wda_1;
    result = imul(result, 31) + getStringHashCode(this.xda_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.yda_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AuthHandshakeResponse))
      return false;
    var tmp0_other_with_cast = other instanceof AuthHandshakeResponse ? other : THROW_CCE();
    if (!(this.wda_1 === tmp0_other_with_cast.wda_1))
      return false;
    if (!(this.xda_1 === tmp0_other_with_cast.xda_1))
      return false;
    if (!(this.yda_1 === tmp0_other_with_cast.yda_1))
      return false;
    return true;
  }
  static zda(seen0, status, username, playerId, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_5().uda_1);
    }
    var $this = this.nd9(seen0, serializationConstructorMarker);
    $this.wda_1 = status;
    if (0 === (seen0 & 2))
      $this.xda_1 = '';
    else
      $this.xda_1 = username;
    if (0 === (seen0 & 4))
      $this.yda_1 = '';
    else
      $this.yda_1 = playerId;
    return $this;
  }
}
class Companion_8 {}
class $serializer_6 {
  constructor() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AuthStatusResponse', this, 3);
    tmp0_serialDesc.rd0('success', false);
    tmp0_serialDesc.sd0(new ProtoNumber(1));
    tmp0_serialDesc.rd0('error', true);
    tmp0_serialDesc.sd0(new ProtoNumber(2));
    tmp0_serialDesc.rd0('token', true);
    tmp0_serialDesc.sd0(new ProtoNumber(3));
    this.adb_1 = tmp0_serialDesc;
  }
  bdb(encoder, value) {
    var tmp0_desc = this.adb_1;
    var tmp1_output = encoder.gcx(tmp0_desc);
    tmp1_output.kcx(tmp0_desc, 0, value.cdb_1);
    if (tmp1_output.jcx(tmp0_desc, 1) ? true : !(value.ddb_1 === '')) {
      tmp1_output.ocx(tmp0_desc, 1, value.ddb_1);
    }
    if (tmp1_output.jcx(tmp0_desc, 2) ? true : !(value.edb_1 === '')) {
      tmp1_output.ocx(tmp0_desc, 2, value.edb_1);
    }
    tmp1_output.qcw(tmp0_desc);
  }
  uct(encoder, value) {
    return this.bdb(encoder, value instanceof AuthStatusResponse ? value : THROW_CCE());
  }
  vct(decoder) {
    var tmp0_desc = this.adb_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = false;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.gcx(tmp0_desc);
    if (tmp7_input.rcw()) {
      tmp4_local0 = tmp7_input.ucw(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.ycw(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.ycw(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.scw(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.ucw(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.ycw(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.ycw(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.jcv(tmp2_index);
        }
      }
    tmp7_input.qcw(tmp0_desc);
    return AuthStatusResponse.fdb(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  tct() {
    return this.adb_1;
  }
  od0() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [BooleanSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  }
}
class AuthStatusResponse extends ServerPacket {
  toString() {
    return 'AuthStatusResponse(success=' + this.cdb_1 + ', error=' + this.ddb_1 + ', token=' + this.edb_1 + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.cdb_1);
    result = imul(result, 31) + getStringHashCode(this.ddb_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.edb_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AuthStatusResponse))
      return false;
    var tmp0_other_with_cast = other instanceof AuthStatusResponse ? other : THROW_CCE();
    if (!(this.cdb_1 === tmp0_other_with_cast.cdb_1))
      return false;
    if (!(this.ddb_1 === tmp0_other_with_cast.ddb_1))
      return false;
    if (!(this.edb_1 === tmp0_other_with_cast.edb_1))
      return false;
    return true;
  }
  static fdb(seen0, success, error, token, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_6().adb_1);
    }
    var $this = this.nd9(seen0, serializationConstructorMarker);
    $this.cdb_1 = success;
    if (0 === (seen0 & 2))
      $this.ddb_1 = '';
    else
      $this.ddb_1 = error;
    if (0 === (seen0 & 4))
      $this.edb_1 = '';
    else
      $this.edb_1 = token;
    return $this;
  }
}
class Companion_9 {}
class $serializer_7 {
  constructor() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('AuthHandshakeRequest', this, 1);
    tmp0_serialDesc.rd0('token', false);
    tmp0_serialDesc.sd0(new ProtoNumber(1));
    this.gdb_1 = tmp0_serialDesc;
  }
  hdb(encoder, value) {
    var tmp0_desc = this.gdb_1;
    var tmp1_output = encoder.gcx(tmp0_desc);
    tmp1_output.ocx(tmp0_desc, 0, value.idb_1);
    tmp1_output.qcw(tmp0_desc);
  }
  uct(encoder, value) {
    return this.hdb(encoder, value instanceof AuthHandshakeRequest ? value : THROW_CCE());
  }
  vct(decoder) {
    var tmp0_desc = this.gdb_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.gcx(tmp0_desc);
    if (tmp5_input.rcw()) {
      tmp4_local0 = tmp5_input.ycw(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.scw(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.ycw(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.jcv(tmp2_index);
        }
      }
    tmp5_input.qcw(tmp0_desc);
    return AuthHandshakeRequest.jdb(tmp3_bitMask0, tmp4_local0, null);
  }
  tct() {
    return this.gdb_1;
  }
  od0() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  }
}
class AuthHandshakeRequest extends ClientPacket {
  constructor(token) {
    super();
    this.idb_1 = token;
  }
  toString() {
    return 'AuthHandshakeRequest(token=' + this.idb_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.idb_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AuthHandshakeRequest))
      return false;
    var tmp0_other_with_cast = other instanceof AuthHandshakeRequest ? other : THROW_CCE();
    if (!(this.idb_1 === tmp0_other_with_cast.idb_1))
      return false;
    return true;
  }
  static jdb(seen0, token, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_7().gdb_1);
    }
    var $this = this.nda(seen0, serializationConstructorMarker);
    $this.idb_1 = token;
    return $this;
  }
}
class Companion_10 {}
class $serializer_8 {
  constructor() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('LoginRequest', this, 2);
    tmp0_serialDesc.rd0('username', false);
    tmp0_serialDesc.sd0(new ProtoNumber(1));
    tmp0_serialDesc.rd0('password', false);
    tmp0_serialDesc.sd0(new ProtoNumber(2));
    this.kdb_1 = tmp0_serialDesc;
  }
  ldb(encoder, value) {
    var tmp0_desc = this.kdb_1;
    var tmp1_output = encoder.gcx(tmp0_desc);
    tmp1_output.ocx(tmp0_desc, 0, value.mdb_1);
    tmp1_output.ocx(tmp0_desc, 1, value.ndb_1);
    tmp1_output.qcw(tmp0_desc);
  }
  uct(encoder, value) {
    return this.ldb(encoder, value instanceof LoginRequest ? value : THROW_CCE());
  }
  vct(decoder) {
    var tmp0_desc = this.kdb_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.gcx(tmp0_desc);
    if (tmp6_input.rcw()) {
      tmp4_local0 = tmp6_input.ycw(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.ycw(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.scw(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.ycw(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.ycw(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.jcv(tmp2_index);
        }
      }
    tmp6_input.qcw(tmp0_desc);
    return LoginRequest.odb(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  tct() {
    return this.kdb_1;
  }
  od0() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  }
}
class LoginRequest extends ClientPacket {
  constructor(username, password) {
    super();
    this.mdb_1 = username;
    this.ndb_1 = password;
  }
  toString() {
    return 'LoginRequest(username=' + this.mdb_1 + ', password=' + this.ndb_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.mdb_1);
    result = imul(result, 31) + getStringHashCode(this.ndb_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LoginRequest))
      return false;
    var tmp0_other_with_cast = other instanceof LoginRequest ? other : THROW_CCE();
    if (!(this.mdb_1 === tmp0_other_with_cast.mdb_1))
      return false;
    if (!(this.ndb_1 === tmp0_other_with_cast.ndb_1))
      return false;
    return true;
  }
  static odb(seen0, username, password, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_8().kdb_1);
    }
    var $this = this.nda(seen0, serializationConstructorMarker);
    $this.mdb_1 = username;
    $this.ndb_1 = password;
    return $this;
  }
}
class Companion_11 {}
class $serializer_9 {
  constructor() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RegisterRequest', this, 2);
    tmp0_serialDesc.rd0('username', false);
    tmp0_serialDesc.sd0(new ProtoNumber(1));
    tmp0_serialDesc.rd0('password', false);
    tmp0_serialDesc.sd0(new ProtoNumber(2));
    this.pdb_1 = tmp0_serialDesc;
  }
  qdb(encoder, value) {
    var tmp0_desc = this.pdb_1;
    var tmp1_output = encoder.gcx(tmp0_desc);
    tmp1_output.ocx(tmp0_desc, 0, value.rdb_1);
    tmp1_output.ocx(tmp0_desc, 1, value.sdb_1);
    tmp1_output.qcw(tmp0_desc);
  }
  uct(encoder, value) {
    return this.qdb(encoder, value instanceof RegisterRequest ? value : THROW_CCE());
  }
  vct(decoder) {
    var tmp0_desc = this.pdb_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.gcx(tmp0_desc);
    if (tmp6_input.rcw()) {
      tmp4_local0 = tmp6_input.ycw(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.ycw(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.scw(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.ycw(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.ycw(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.jcv(tmp2_index);
        }
      }
    tmp6_input.qcw(tmp0_desc);
    return RegisterRequest.tdb(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  tct() {
    return this.pdb_1;
  }
  od0() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  }
}
class RegisterRequest extends ClientPacket {
  constructor(username, password) {
    super();
    this.rdb_1 = username;
    this.sdb_1 = password;
  }
  toString() {
    return 'RegisterRequest(username=' + this.rdb_1 + ', password=' + this.sdb_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.rdb_1);
    result = imul(result, 31) + getStringHashCode(this.sdb_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RegisterRequest))
      return false;
    var tmp0_other_with_cast = other instanceof RegisterRequest ? other : THROW_CCE();
    if (!(this.rdb_1 === tmp0_other_with_cast.rdb_1))
      return false;
    if (!(this.sdb_1 === tmp0_other_with_cast.sdb_1))
      return false;
    return true;
  }
  static tdb(seen0, username, password, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_9().pdb_1);
    }
    var $this = this.nda(seen0, serializationConstructorMarker);
    $this.rdb_1 = username;
    $this.sdb_1 = password;
    return $this;
  }
}
class Companion_12 {}
class $serializer_10 {
  constructor() {
    $serializer_instance_10 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SetUsernameResponse', this, 2);
    tmp0_serialDesc.rd0('success', false);
    tmp0_serialDesc.sd0(new ProtoNumber(1));
    tmp0_serialDesc.rd0('error', true);
    tmp0_serialDesc.sd0(new ProtoNumber(2));
    this.udb_1 = tmp0_serialDesc;
  }
  vdb(encoder, value) {
    var tmp0_desc = this.udb_1;
    var tmp1_output = encoder.gcx(tmp0_desc);
    tmp1_output.kcx(tmp0_desc, 0, value.wdb_1);
    if (tmp1_output.jcx(tmp0_desc, 1) ? true : !(value.xdb_1 === '')) {
      tmp1_output.ocx(tmp0_desc, 1, value.xdb_1);
    }
    tmp1_output.qcw(tmp0_desc);
  }
  uct(encoder, value) {
    return this.vdb(encoder, value instanceof SetUsernameResponse ? value : THROW_CCE());
  }
  vct(decoder) {
    var tmp0_desc = this.udb_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = false;
    var tmp5_local1 = null;
    var tmp6_input = decoder.gcx(tmp0_desc);
    if (tmp6_input.rcw()) {
      tmp4_local0 = tmp6_input.ucw(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.ycw(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.scw(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.ucw(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.ycw(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.jcv(tmp2_index);
        }
      }
    tmp6_input.qcw(tmp0_desc);
    return SetUsernameResponse.ydb(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  tct() {
    return this.udb_1;
  }
  od0() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [BooleanSerializer_getInstance(), StringSerializer_getInstance()];
  }
}
class SetUsernameResponse extends ServerPacket {
  toString() {
    return 'SetUsernameResponse(success=' + this.wdb_1 + ', error=' + this.xdb_1 + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.wdb_1);
    result = imul(result, 31) + getStringHashCode(this.xdb_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SetUsernameResponse))
      return false;
    var tmp0_other_with_cast = other instanceof SetUsernameResponse ? other : THROW_CCE();
    if (!(this.wdb_1 === tmp0_other_with_cast.wdb_1))
      return false;
    if (!(this.xdb_1 === tmp0_other_with_cast.xdb_1))
      return false;
    return true;
  }
  static ydb(seen0, success, error, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_10().udb_1);
    }
    var $this = this.nd9(seen0, serializationConstructorMarker);
    $this.wdb_1 = success;
    if (0 === (seen0 & 2))
      $this.xdb_1 = '';
    else
      $this.xdb_1 = error;
    return $this;
  }
}
class Companion_13 {}
class $serializer_11 {
  constructor() {
    $serializer_instance_11 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('PlayerDataRequest', this, 3);
    tmp0_serialDesc.rd0('x', false);
    tmp0_serialDesc.sd0(new ProtoNumber(1));
    tmp0_serialDesc.rd0('y', false);
    tmp0_serialDesc.sd0(new ProtoNumber(2));
    tmp0_serialDesc.rd0('username', true);
    tmp0_serialDesc.sd0(new ProtoNumber(3));
    this.zdb_1 = tmp0_serialDesc;
  }
  adc(encoder, value) {
    var tmp0_desc = this.zdb_1;
    var tmp1_output = encoder.gcx(tmp0_desc);
    tmp1_output.ncx(tmp0_desc, 0, value.bdc_1);
    tmp1_output.ncx(tmp0_desc, 1, value.cdc_1);
    if (tmp1_output.jcx(tmp0_desc, 2) ? true : !(value.ddc_1 === '')) {
      tmp1_output.ocx(tmp0_desc, 2, value.ddc_1);
    }
    tmp1_output.qcw(tmp0_desc);
  }
  uct(encoder, value) {
    return this.adc(encoder, value instanceof PlayerDataRequest ? value : THROW_CCE());
  }
  vct(decoder) {
    var tmp0_desc = this.zdb_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = null;
    var tmp7_input = decoder.gcx(tmp0_desc);
    if (tmp7_input.rcw()) {
      tmp4_local0 = tmp7_input.xcw(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.xcw(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.ycw(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.scw(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.xcw(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.xcw(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.ycw(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.jcv(tmp2_index);
        }
      }
    tmp7_input.qcw(tmp0_desc);
    return PlayerDataRequest.edc(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  tct() {
    return this.zdb_1;
  }
  od0() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [FloatSerializer_getInstance(), FloatSerializer_getInstance(), StringSerializer_getInstance()];
  }
}
class PlayerDataRequest extends ClientPacket {
  toString() {
    return 'PlayerDataRequest(x=' + this.bdc_1 + ', y=' + this.cdc_1 + ', username=' + this.ddc_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.bdc_1);
    result = imul(result, 31) + getNumberHashCode(this.cdc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ddc_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlayerDataRequest))
      return false;
    var tmp0_other_with_cast = other instanceof PlayerDataRequest ? other : THROW_CCE();
    if (!equals(this.bdc_1, tmp0_other_with_cast.bdc_1))
      return false;
    if (!equals(this.cdc_1, tmp0_other_with_cast.cdc_1))
      return false;
    if (!(this.ddc_1 === tmp0_other_with_cast.ddc_1))
      return false;
    return true;
  }
  static edc(seen0, x, y, username, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_11().zdb_1);
    }
    var $this = this.nda(seen0, serializationConstructorMarker);
    $this.bdc_1 = x;
    $this.cdc_1 = y;
    if (0 === (seen0 & 4))
      $this.ddc_1 = '';
    else
      $this.ddc_1 = username;
    return $this;
  }
}
class Companion_14 {}
class $serializer_12 {
  constructor() {
    $serializer_instance_12 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('SetUsernameRequest', this, 1);
    tmp0_serialDesc.rd0('username', false);
    tmp0_serialDesc.sd0(new ProtoNumber(1));
    this.fdc_1 = tmp0_serialDesc;
  }
  gdc(encoder, value) {
    var tmp0_desc = this.fdc_1;
    var tmp1_output = encoder.gcx(tmp0_desc);
    tmp1_output.ocx(tmp0_desc, 0, value.hdc_1);
    tmp1_output.qcw(tmp0_desc);
  }
  uct(encoder, value) {
    return this.gdc(encoder, value instanceof SetUsernameRequest ? value : THROW_CCE());
  }
  vct(decoder) {
    var tmp0_desc = this.fdc_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.gcx(tmp0_desc);
    if (tmp5_input.rcw()) {
      tmp4_local0 = tmp5_input.ycw(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.scw(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.ycw(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.jcv(tmp2_index);
        }
      }
    tmp5_input.qcw(tmp0_desc);
    return SetUsernameRequest.idc(tmp3_bitMask0, tmp4_local0, null);
  }
  tct() {
    return this.fdc_1;
  }
  od0() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  }
}
class SetUsernameRequest extends ClientPacket {
  toString() {
    return 'SetUsernameRequest(username=' + this.hdc_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.hdc_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SetUsernameRequest))
      return false;
    var tmp0_other_with_cast = other instanceof SetUsernameRequest ? other : THROW_CCE();
    if (!(this.hdc_1 === tmp0_other_with_cast.hdc_1))
      return false;
    return true;
  }
  static idc(seen0, username, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_12().fdc_1);
    }
    var $this = this.nda(seen0, serializationConstructorMarker);
    $this.hdc_1 = username;
    return $this;
  }
}
class ClientContext {}
class PacketHandler {}
class PacketDispatcher {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.kdc_1 = LinkedHashMap.bc();
  }
  ldc(clazz, handler) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.kdc_1;
    var value = isInterface(handler, PacketHandler) ? handler : THROW_CCE();
    this_0.e3(clazz, value);
  }
  mdc(packet, context, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_dispatch__vq5iya.bind(VOID, this, packet, context), $completion);
  }
}
class Companion_15 {
  constructor() {
    Companion_instance_15 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.ndc_1 = [new ArrayListSerializer(IntSerializer_getInstance()), null, null, null, null];
  }
}
class $serializer_13 {
  constructor() {
    $serializer_instance_13 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.samples.clientserver.networking.TiledChunk', this, 5);
    tmp0_serialDesc.rd0('data', false);
    tmp0_serialDesc.rd0('height', false);
    tmp0_serialDesc.rd0('width', false);
    tmp0_serialDesc.rd0('x', false);
    tmp0_serialDesc.rd0('y', false);
    this.odc_1 = tmp0_serialDesc;
  }
  pdc(encoder, value) {
    var tmp0_desc = this.odc_1;
    var tmp1_output = encoder.gcx(tmp0_desc);
    var tmp2_cached = Companion_getInstance_15().ndc_1;
    tmp1_output.pcx(tmp0_desc, 0, tmp2_cached[0], value.qdc_1);
    tmp1_output.mcx(tmp0_desc, 1, value.rdc_1);
    tmp1_output.mcx(tmp0_desc, 2, value.sdc_1);
    tmp1_output.mcx(tmp0_desc, 3, value.tdc_1);
    tmp1_output.mcx(tmp0_desc, 4, value.udc_1);
    tmp1_output.qcw(tmp0_desc);
  }
  uct(encoder, value) {
    return this.pdc(encoder, value instanceof TiledChunk ? value : THROW_CCE());
  }
  vct(decoder) {
    var tmp0_desc = this.odc_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_local4 = 0;
    var tmp9_input = decoder.gcx(tmp0_desc);
    var tmp10_cached = Companion_getInstance_15().ndc_1;
    if (tmp9_input.rcw()) {
      tmp4_local0 = tmp9_input.zcw(tmp0_desc, 0, tmp10_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.wcw(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.wcw(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.wcw(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.wcw(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.scw(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.zcw(tmp0_desc, 0, tmp10_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.wcw(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.wcw(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.wcw(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.wcw(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.jcv(tmp2_index);
        }
      }
    tmp9_input.qcw(tmp0_desc);
    return TiledChunk.vdc(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  tct() {
    return this.odc_1;
  }
  od0() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_15().ndc_1[0], IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class TiledChunk {
  toString() {
    return 'TiledChunk(data=' + toString(this.qdc_1) + ', height=' + this.rdc_1 + ', width=' + this.sdc_1 + ', x=' + this.tdc_1 + ', y=' + this.udc_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.qdc_1);
    result = imul(result, 31) + this.rdc_1 | 0;
    result = imul(result, 31) + this.sdc_1 | 0;
    result = imul(result, 31) + this.tdc_1 | 0;
    result = imul(result, 31) + this.udc_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TiledChunk))
      return false;
    var tmp0_other_with_cast = other instanceof TiledChunk ? other : THROW_CCE();
    if (!equals(this.qdc_1, tmp0_other_with_cast.qdc_1))
      return false;
    if (!(this.rdc_1 === tmp0_other_with_cast.rdc_1))
      return false;
    if (!(this.sdc_1 === tmp0_other_with_cast.sdc_1))
      return false;
    if (!(this.tdc_1 === tmp0_other_with_cast.tdc_1))
      return false;
    if (!(this.udc_1 === tmp0_other_with_cast.udc_1))
      return false;
    return true;
  }
  static vdc(seen0, data, height, width, x, y, serializationConstructorMarker) {
    Companion_getInstance_15();
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_13().odc_1);
    }
    var $this = createThis(this);
    $this.qdc_1 = data;
    $this.rdc_1 = height;
    $this.sdc_1 = width;
    $this.tdc_1 = x;
    $this.udc_1 = y;
    return $this;
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_16 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.wdc_1 = [null, null, null, null, new ArrayListSerializer($serializer_getInstance_15()), new ArrayListSerializer($serializer_getInstance_16())];
  }
}
class $serializer_14 {
  constructor() {
    $serializer_instance_14 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.samples.clientserver.networking.TiledMap', this, 6);
    tmp0_serialDesc.rd0('width', false);
    tmp0_serialDesc.rd0('height', false);
    tmp0_serialDesc.rd0('tilewidth', false);
    tmp0_serialDesc.rd0('tileheight', false);
    tmp0_serialDesc.rd0('layers', false);
    tmp0_serialDesc.rd0('tilesets', false);
    this.xdc_1 = tmp0_serialDesc;
  }
  ydc(encoder, value) {
    var tmp0_desc = this.xdc_1;
    var tmp1_output = encoder.gcx(tmp0_desc);
    var tmp2_cached = Companion_getInstance_16().wdc_1;
    tmp1_output.mcx(tmp0_desc, 0, value.zdc_1);
    tmp1_output.mcx(tmp0_desc, 1, value.add_1);
    tmp1_output.mcx(tmp0_desc, 2, value.bdd_1);
    tmp1_output.mcx(tmp0_desc, 3, value.cdd_1);
    tmp1_output.pcx(tmp0_desc, 4, tmp2_cached[4], value.ddd_1);
    tmp1_output.pcx(tmp0_desc, 5, tmp2_cached[5], value.edd_1);
    tmp1_output.qcw(tmp0_desc);
  }
  uct(encoder, value) {
    return this.ydc(encoder, value instanceof TiledMap ? value : THROW_CCE());
  }
  vct(decoder) {
    var tmp0_desc = this.xdc_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.gcx(tmp0_desc);
    var tmp11_cached = Companion_getInstance_16().wdc_1;
    if (tmp10_input.rcw()) {
      tmp4_local0 = tmp10_input.wcw(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.wcw(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.wcw(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.wcw(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.zcw(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.zcw(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.scw(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.wcw(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.wcw(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.wcw(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.wcw(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.zcw(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.zcw(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException.jcv(tmp2_index);
        }
      }
    tmp10_input.qcw(tmp0_desc);
    return TiledMap.fdd(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  }
  tct() {
    return this.xdc_1;
  }
  od0() {
    var tmp0_cached = Companion_getInstance_16().wdc_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[4], tmp0_cached[5]];
  }
}
class TiledMap {
  constructor(width, height, tilewidth, tileheight, layers, tilesets) {
    Companion_getInstance_16();
    this.zdc_1 = width;
    this.add_1 = height;
    this.bdd_1 = tilewidth;
    this.cdd_1 = tileheight;
    this.ddd_1 = layers;
    this.edd_1 = tilesets;
  }
  gdd(x, y) {
    // Inline function 'kotlin.math.floor' call
    var x_0 = x / this.bdd_1;
    var tmp$ret$0 = Math.floor(x_0);
    var col = numberToInt(tmp$ret$0);
    // Inline function 'kotlin.math.floor' call
    var x_1 = y / this.cdd_1;
    var tmp$ret$1 = Math.floor(x_1);
    var row = numberToInt(tmp$ret$1);
    if (this.ddd_1.g1()) {
      return true;
    }
    var layer = this.ddd_1.d1(0);
    var gid = layer.ldd(col, row, this.zdc_1);
    return !(gid === 37);
  }
  mdd(x, y, r) {
    var rx = r + 1.0;
    var ry = r + 2.0;
    return this.gdd(x - rx, y - ry) || this.gdd(x + rx, y - ry) || this.gdd(x - rx, y + ry) || this.gdd(x + rx, y + ry);
  }
  ndd(currentX, currentY, dx, step, radius) {
    var targetX = currentX + dx * step;
    if (!this.mdd(targetX, currentY, radius)) {
      return targetX;
    }
    var low = 0.0;
    var high = step;
    var best = 0.0;
    var inductionVariable = 0;
    if (inductionVariable < 8)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var mid = (low + high) / 2;
        var testX = currentX + dx * mid;
        if (!this.mdd(testX, currentY, radius)) {
          best = mid;
          low = mid;
        } else {
          high = mid;
        }
      }
       while (inductionVariable < 8);
    return currentX + dx * best;
  }
  odd(currentX, currentY, dy, step, radius) {
    var targetY = currentY + dy * step;
    if (!this.mdd(currentX, targetY, radius)) {
      return targetY;
    }
    var low = 0.0;
    var high = step;
    var best = 0.0;
    var inductionVariable = 0;
    if (inductionVariable < 8)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var mid = (low + high) / 2;
        var testY = currentY + dy * mid;
        if (!this.mdd(currentX, testY, radius)) {
          best = mid;
          low = mid;
        } else {
          high = mid;
        }
      }
       while (inductionVariable < 8);
    return currentY + dy * best;
  }
  pdd(width, height, tilewidth, tileheight, layers, tilesets) {
    return new TiledMap(width, height, tilewidth, tileheight, layers, tilesets);
  }
  qdd(width, height, tilewidth, tileheight, layers, tilesets, $super) {
    width = width === VOID ? this.zdc_1 : width;
    height = height === VOID ? this.add_1 : height;
    tilewidth = tilewidth === VOID ? this.bdd_1 : tilewidth;
    tileheight = tileheight === VOID ? this.cdd_1 : tileheight;
    layers = layers === VOID ? this.ddd_1 : layers;
    tilesets = tilesets === VOID ? this.edd_1 : tilesets;
    return $super === VOID ? this.pdd(width, height, tilewidth, tileheight, layers, tilesets) : $super.pdd.call(this, width, height, tilewidth, tileheight, layers, tilesets);
  }
  toString() {
    return 'TiledMap(width=' + this.zdc_1 + ', height=' + this.add_1 + ', tilewidth=' + this.bdd_1 + ', tileheight=' + this.cdd_1 + ', layers=' + toString(this.ddd_1) + ', tilesets=' + toString(this.edd_1) + ')';
  }
  hashCode() {
    var result = this.zdc_1;
    result = imul(result, 31) + this.add_1 | 0;
    result = imul(result, 31) + this.bdd_1 | 0;
    result = imul(result, 31) + this.cdd_1 | 0;
    result = imul(result, 31) + hashCode(this.ddd_1) | 0;
    result = imul(result, 31) + hashCode(this.edd_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TiledMap))
      return false;
    var tmp0_other_with_cast = other instanceof TiledMap ? other : THROW_CCE();
    if (!(this.zdc_1 === tmp0_other_with_cast.zdc_1))
      return false;
    if (!(this.add_1 === tmp0_other_with_cast.add_1))
      return false;
    if (!(this.bdd_1 === tmp0_other_with_cast.bdd_1))
      return false;
    if (!(this.cdd_1 === tmp0_other_with_cast.cdd_1))
      return false;
    if (!equals(this.ddd_1, tmp0_other_with_cast.ddd_1))
      return false;
    if (!equals(this.edd_1, tmp0_other_with_cast.edd_1))
      return false;
    return true;
  }
  static fdd(seen0, width, height, tilewidth, tileheight, layers, tilesets, serializationConstructorMarker) {
    Companion_getInstance_16();
    if (!(63 === (63 & seen0))) {
      throwMissingFieldException(seen0, 63, $serializer_getInstance_14().xdc_1);
    }
    var $this = createThis(this);
    $this.zdc_1 = width;
    $this.add_1 = height;
    $this.bdd_1 = tilewidth;
    $this.cdd_1 = tileheight;
    $this.ddd_1 = layers;
    $this.edd_1 = tilesets;
    return $this;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_17 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.rdd_1 = [new ArrayListSerializer($serializer_getInstance_13()), new ArrayListSerializer(IntSerializer_getInstance()), null, null];
  }
}
class $serializer_15 {
  constructor() {
    $serializer_instance_15 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.samples.clientserver.networking.TiledLayer', this, 4);
    tmp0_serialDesc.rd0('chunks', true);
    tmp0_serialDesc.rd0('data', true);
    tmp0_serialDesc.rd0('name', false);
    tmp0_serialDesc.rd0('type', false);
    this.sdd_1 = tmp0_serialDesc;
  }
  tdd(encoder, value) {
    var tmp0_desc = this.sdd_1;
    var tmp1_output = encoder.gcx(tmp0_desc);
    var tmp2_cached = Companion_getInstance_17().rdd_1;
    if (tmp1_output.jcx(tmp0_desc, 0) ? true : !equals(value.hdd_1, emptyList())) {
      tmp1_output.pcx(tmp0_desc, 0, tmp2_cached[0], value.hdd_1);
    }
    if (tmp1_output.jcx(tmp0_desc, 1) ? true : !equals(value.idd_1, emptyList())) {
      tmp1_output.pcx(tmp0_desc, 1, tmp2_cached[1], value.idd_1);
    }
    tmp1_output.ocx(tmp0_desc, 2, value.jdd_1);
    tmp1_output.ocx(tmp0_desc, 3, value.kdd_1);
    tmp1_output.qcw(tmp0_desc);
  }
  uct(encoder, value) {
    return this.tdd(encoder, value instanceof TiledLayer ? value : THROW_CCE());
  }
  vct(decoder) {
    var tmp0_desc = this.sdd_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.gcx(tmp0_desc);
    var tmp9_cached = Companion_getInstance_17().rdd_1;
    if (tmp8_input.rcw()) {
      tmp4_local0 = tmp8_input.zcw(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.zcw(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.ycw(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.ycw(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.scw(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.zcw(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.zcw(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.ycw(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.ycw(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException.jcv(tmp2_index);
        }
      }
    tmp8_input.qcw(tmp0_desc);
    return TiledLayer.udd(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  }
  tct() {
    return this.sdd_1;
  }
  od0() {
    var tmp0_cached = Companion_getInstance_17().rdd_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1], StringSerializer_getInstance(), StringSerializer_getInstance()];
  }
}
class TiledLayer {
  constructor(chunks, data, name, type) {
    Companion_getInstance_17();
    chunks = chunks === VOID ? emptyList() : chunks;
    data = data === VOID ? emptyList() : data;
    this.hdd_1 = chunks;
    this.idd_1 = data;
    this.jdd_1 = name;
    this.kdd_1 = type;
  }
  ldd(col, row, mapWidth) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.idd_1.g1()) {
      var idx = imul(row, mapWidth) + col | 0;
      if (0 <= idx ? idx <= (this.idd_1.e1() - 1 | 0) : false) {
        return this.idd_1.d1(idx);
      }
      return 0;
    }
    var _iterator__ex2g4s = this.hdd_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var chunk = _iterator__ex2g4s.c1();
      if (col >= chunk.tdc_1 && col < (chunk.tdc_1 + chunk.sdc_1 | 0) && row >= chunk.udc_1 && row < (chunk.udc_1 + chunk.rdc_1 | 0)) {
        var localCol = col - chunk.tdc_1 | 0;
        var localRow = row - chunk.udc_1 | 0;
        var idx_0 = imul(localRow, chunk.sdc_1) + localCol | 0;
        if (0 <= idx_0 ? idx_0 <= (chunk.qdc_1.e1() - 1 | 0) : false) {
          return chunk.qdc_1.d1(idx_0);
        }
      }
    }
    return 0;
  }
  vdd(chunks, data, name, type) {
    return new TiledLayer(chunks, data, name, type);
  }
  wdd(chunks, data, name, type, $super) {
    chunks = chunks === VOID ? this.hdd_1 : chunks;
    data = data === VOID ? this.idd_1 : data;
    name = name === VOID ? this.jdd_1 : name;
    type = type === VOID ? this.kdd_1 : type;
    return $super === VOID ? this.vdd(chunks, data, name, type) : $super.vdd.call(this, chunks, data, name, type);
  }
  toString() {
    return 'TiledLayer(chunks=' + toString(this.hdd_1) + ', data=' + toString(this.idd_1) + ', name=' + this.jdd_1 + ', type=' + this.kdd_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.hdd_1);
    result = imul(result, 31) + hashCode(this.idd_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.jdd_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.kdd_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TiledLayer))
      return false;
    var tmp0_other_with_cast = other instanceof TiledLayer ? other : THROW_CCE();
    if (!equals(this.hdd_1, tmp0_other_with_cast.hdd_1))
      return false;
    if (!equals(this.idd_1, tmp0_other_with_cast.idd_1))
      return false;
    if (!(this.jdd_1 === tmp0_other_with_cast.jdd_1))
      return false;
    if (!(this.kdd_1 === tmp0_other_with_cast.kdd_1))
      return false;
    return true;
  }
  static udd(seen0, chunks, data, name, type, serializationConstructorMarker) {
    Companion_getInstance_17();
    if (!(12 === (12 & seen0))) {
      throwMissingFieldException(seen0, 12, $serializer_getInstance_15().sdd_1);
    }
    var $this = createThis(this);
    if (0 === (seen0 & 1))
      $this.hdd_1 = emptyList();
    else
      $this.hdd_1 = chunks;
    if (0 === (seen0 & 2))
      $this.idd_1 = emptyList();
    else
      $this.idd_1 = data;
    $this.jdd_1 = name;
    $this.kdd_1 = type;
    return $this;
  }
}
class Companion_18 {}
class $serializer_16 {
  constructor() {
    $serializer_instance_16 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.samples.clientserver.networking.TiledSet', this, 2);
    tmp0_serialDesc.rd0('firstgid', false);
    tmp0_serialDesc.rd0('columns', true);
    this.xdd_1 = tmp0_serialDesc;
  }
  ydd(encoder, value) {
    var tmp0_desc = this.xdd_1;
    var tmp1_output = encoder.gcx(tmp0_desc);
    tmp1_output.mcx(tmp0_desc, 0, value.zdd_1);
    if (tmp1_output.jcx(tmp0_desc, 1) ? true : !(value.ade_1 === 0)) {
      tmp1_output.mcx(tmp0_desc, 1, value.ade_1);
    }
    tmp1_output.qcw(tmp0_desc);
  }
  uct(encoder, value) {
    return this.ydd(encoder, value instanceof TiledSet ? value : THROW_CCE());
  }
  vct(decoder) {
    var tmp0_desc = this.xdd_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.gcx(tmp0_desc);
    if (tmp6_input.rcw()) {
      tmp4_local0 = tmp6_input.wcw(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.wcw(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.scw(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.wcw(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.wcw(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.jcv(tmp2_index);
        }
      }
    tmp6_input.qcw(tmp0_desc);
    return TiledSet.bde(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  tct() {
    return this.xdd_1;
  }
  od0() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance()];
  }
}
class TiledSet {
  toString() {
    return 'TiledSet(firstgid=' + this.zdd_1 + ', columns=' + this.ade_1 + ')';
  }
  hashCode() {
    var result = this.zdd_1;
    result = imul(result, 31) + this.ade_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TiledSet))
      return false;
    var tmp0_other_with_cast = other instanceof TiledSet ? other : THROW_CCE();
    if (!(this.zdd_1 === tmp0_other_with_cast.zdd_1))
      return false;
    if (!(this.ade_1 === tmp0_other_with_cast.ade_1))
      return false;
    return true;
  }
  static bde(seen0, firstgid, columns, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_16().xdd_1);
    }
    var $this = createThis(this);
    $this.zdd_1 = firstgid;
    if (0 === (seen0 & 2))
      $this.ade_1 = 0;
    else
      $this.ade_1 = columns;
    return $this;
  }
}
//endregion
var mySharedString;
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new $serializer();
  return $serializer_instance;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new $serializer_0();
  return $serializer_instance_0;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new $serializer_1();
  return $serializer_instance_1;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 === VOID)
    new $serializer_2();
  return $serializer_instance_2;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 === VOID)
    new $serializer_3();
  return $serializer_instance_3;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.kda_1.r1();
}
function ServerPacket$Companion$_anonymous__g5b1ss() {
  var tmp = getKClass(ServerPacket);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(AuthHandshakeResponse), getKClass(AuthStatusResponse), getKClass(GameState), getKClass(MapChunkUpdatePacket), getKClass(MapDataPacket), getKClass(PlayerData), getKClass(SetUsernameResponse)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_1 = [$serializer_getInstance_5(), $serializer_getInstance_6(), $serializer_getInstance(), $serializer_getInstance_1(), $serializer_getInstance_2(), $serializer_getInstance_3(), $serializer_getInstance_10()];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$8 = [];
  return SealedClassSerializer.ucu('korlibs.samples.clientserver.ServerPacket', tmp, tmp_0, tmp_1, tmp$ret$8);
}
var Companion_instance_4;
function Companion_getInstance_4() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.mda_1.r1();
}
function ClientPacket$Companion$_anonymous__1ag50k() {
  var tmp = getKClass(ClientPacket);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(AuthHandshakeRequest), getKClass(LoginRequest), getKClass(MovePacket), getKClass(PlayerDataRequest), getKClass(RegisterRequest), getKClass(SetUsernameRequest)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_1 = [$serializer_getInstance_7(), $serializer_getInstance_8(), $serializer_getInstance_4(), $serializer_getInstance_11(), $serializer_getInstance_9(), $serializer_getInstance_12()];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$8 = [];
  return SealedClassSerializer.ucu('korlibs.samples.clientserver.ClientPacket', tmp, tmp_0, tmp_1, tmp$ret$8);
}
var Companion_instance_5;
function Companion_getInstance_5() {
  if (Companion_instance_5 === VOID)
    new Companion_5();
  return Companion_instance_5;
}
var Companion_instance_6;
function Companion_getInstance_6() {
  return Companion_instance_6;
}
var $serializer_instance_4;
function $serializer_getInstance_4() {
  if ($serializer_instance_4 === VOID)
    new $serializer_4();
  return $serializer_instance_4;
}
var Companion_instance_7;
function Companion_getInstance_7() {
  return Companion_instance_7;
}
var $serializer_instance_5;
function $serializer_getInstance_5() {
  if ($serializer_instance_5 === VOID)
    new $serializer_5();
  return $serializer_instance_5;
}
var Companion_instance_8;
function Companion_getInstance_8() {
  return Companion_instance_8;
}
var $serializer_instance_6;
function $serializer_getInstance_6() {
  if ($serializer_instance_6 === VOID)
    new $serializer_6();
  return $serializer_instance_6;
}
var Companion_instance_9;
function Companion_getInstance_9() {
  return Companion_instance_9;
}
var $serializer_instance_7;
function $serializer_getInstance_7() {
  if ($serializer_instance_7 === VOID)
    new $serializer_7();
  return $serializer_instance_7;
}
var Companion_instance_10;
function Companion_getInstance_10() {
  return Companion_instance_10;
}
var $serializer_instance_8;
function $serializer_getInstance_8() {
  if ($serializer_instance_8 === VOID)
    new $serializer_8();
  return $serializer_instance_8;
}
var Companion_instance_11;
function Companion_getInstance_11() {
  return Companion_instance_11;
}
var $serializer_instance_9;
function $serializer_getInstance_9() {
  if ($serializer_instance_9 === VOID)
    new $serializer_9();
  return $serializer_instance_9;
}
var Companion_instance_12;
function Companion_getInstance_12() {
  return Companion_instance_12;
}
var $serializer_instance_10;
function $serializer_getInstance_10() {
  if ($serializer_instance_10 === VOID)
    new $serializer_10();
  return $serializer_instance_10;
}
var Companion_instance_13;
function Companion_getInstance_13() {
  return Companion_instance_13;
}
var $serializer_instance_11;
function $serializer_getInstance_11() {
  if ($serializer_instance_11 === VOID)
    new $serializer_11();
  return $serializer_instance_11;
}
var Companion_instance_14;
function Companion_getInstance_14() {
  return Companion_instance_14;
}
var $serializer_instance_12;
function $serializer_getInstance_12() {
  if ($serializer_instance_12 === VOID)
    new $serializer_12();
  return $serializer_instance_12;
}
function *_generator_dispatch__vq5iya($this, packet, context, $completion) {
  var tmp0_elvis_lhs = $this.kdc_1.c3(getKClassFromExpression(packet));
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var handler = tmp;
  var tmp_0 = (isInterface(handler, PacketHandler) ? handler : THROW_CCE()).jdc(packet, context, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var Companion_instance_15;
function Companion_getInstance_15() {
  if (Companion_instance_15 === VOID)
    new Companion_15();
  return Companion_instance_15;
}
var $serializer_instance_13;
function $serializer_getInstance_13() {
  if ($serializer_instance_13 === VOID)
    new $serializer_13();
  return $serializer_instance_13;
}
var Companion_instance_16;
function Companion_getInstance_16() {
  if (Companion_instance_16 === VOID)
    new Companion_16();
  return Companion_instance_16;
}
var $serializer_instance_14;
function $serializer_getInstance_14() {
  if ($serializer_instance_14 === VOID)
    new $serializer_14();
  return $serializer_instance_14;
}
var Companion_instance_17;
function Companion_getInstance_17() {
  if (Companion_instance_17 === VOID)
    new Companion_17();
  return Companion_instance_17;
}
var $serializer_instance_15;
function $serializer_getInstance_15() {
  if ($serializer_instance_15 === VOID)
    new $serializer_15();
  return $serializer_instance_15;
}
var Companion_instance_18;
function Companion_getInstance_18() {
  return Companion_instance_18;
}
var $serializer_instance_16;
function $serializer_getInstance_16() {
  if ($serializer_instance_16 === VOID)
    new $serializer_16();
  return $serializer_instance_16;
}
//region block: post-declaration
initMetadataForCompanion(Companion);
protoOf($serializer).pd0 = typeParametersSerializers;
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ServerPacket, 'ServerPacket', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_4});
initMetadataForClass(GameState, 'GameState', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
initMetadataForCompanion(Companion_0);
protoOf($serializer_0).pd0 = typeParametersSerializers;
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PlayerState, 'PlayerState', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForCompanion(Companion_1);
protoOf($serializer_1).pd0 = typeParametersSerializers;
initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(MapChunkUpdatePacket, 'MapChunkUpdatePacket', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
initMetadataForCompanion(Companion_2);
protoOf($serializer_2).pd0 = typeParametersSerializers;
initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(MapDataPacket, 'MapDataPacket', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
initMetadataForCompanion(Companion_3);
protoOf($serializer_3).pd0 = typeParametersSerializers;
initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PlayerData, 'PlayerData', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(ClientPacket, 'ClientPacket', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_5});
initMetadataForCompanion(Companion_6);
protoOf($serializer_4).pd0 = typeParametersSerializers;
initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(MovePacket, 'MovePacket', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
initMetadataForCompanion(Companion_7);
protoOf($serializer_5).pd0 = typeParametersSerializers;
initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AuthHandshakeResponse, 'AuthHandshakeResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
initMetadataForCompanion(Companion_8);
protoOf($serializer_6).pd0 = typeParametersSerializers;
initMetadataForObject($serializer_6, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AuthStatusResponse, 'AuthStatusResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
initMetadataForCompanion(Companion_9);
protoOf($serializer_7).pd0 = typeParametersSerializers;
initMetadataForObject($serializer_7, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AuthHandshakeRequest, 'AuthHandshakeRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
initMetadataForCompanion(Companion_10);
protoOf($serializer_8).pd0 = typeParametersSerializers;
initMetadataForObject($serializer_8, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LoginRequest, 'LoginRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
initMetadataForCompanion(Companion_11);
protoOf($serializer_9).pd0 = typeParametersSerializers;
initMetadataForObject($serializer_9, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RegisterRequest, 'RegisterRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
initMetadataForCompanion(Companion_12);
protoOf($serializer_10).pd0 = typeParametersSerializers;
initMetadataForObject($serializer_10, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SetUsernameResponse, 'SetUsernameResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_10});
initMetadataForCompanion(Companion_13);
protoOf($serializer_11).pd0 = typeParametersSerializers;
initMetadataForObject($serializer_11, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PlayerDataRequest, 'PlayerDataRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_11});
initMetadataForCompanion(Companion_14);
protoOf($serializer_12).pd0 = typeParametersSerializers;
initMetadataForObject($serializer_12, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SetUsernameRequest, 'SetUsernameRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_12});
initMetadataForInterface(ClientContext, 'ClientContext', VOID, VOID, VOID, [1]);
initMetadataForInterface(PacketHandler, 'PacketHandler', VOID, VOID, VOID, [2]);
initMetadataForClass(PacketDispatcher, 'PacketDispatcher', PacketDispatcher, VOID, VOID, [2]);
initMetadataForCompanion(Companion_15);
protoOf($serializer_13).pd0 = typeParametersSerializers;
initMetadataForObject($serializer_13, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TiledChunk, 'TiledChunk', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_13});
initMetadataForCompanion(Companion_16);
protoOf($serializer_14).pd0 = typeParametersSerializers;
initMetadataForObject($serializer_14, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TiledMap, 'TiledMap', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_14});
initMetadataForCompanion(Companion_17);
protoOf($serializer_15).pd0 = typeParametersSerializers;
initMetadataForObject($serializer_15, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TiledLayer, 'TiledLayer', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_15});
initMetadataForCompanion(Companion_18);
protoOf($serializer_16).pd0 = typeParametersSerializers;
initMetadataForObject($serializer_16, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(TiledSet, 'TiledSet', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_16});
//endregion
//region block: init
mySharedString = 'THIS IS A COMMON STRING!';
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
Companion_instance_3 = new Companion_3();
Companion_instance_6 = new Companion_6();
Companion_instance_7 = new Companion_7();
Companion_instance_8 = new Companion_8();
Companion_instance_9 = new Companion_9();
Companion_instance_10 = new Companion_10();
Companion_instance_11 = new Companion_11();
Companion_instance_12 = new Companion_12();
Companion_instance_13 = new Companion_13();
Companion_instance_14 = new Companion_14();
Companion_instance_18 = new Companion_18();
//endregion
//region block: exports
export {
  Companion_getInstance_5 as Companion_getInstanceylu41py2t57r,
  Companion_getInstance_4 as Companion_getInstance2mholsbmtd60v,
  ClientContext as ClientContext1mhsfx1tilrk5,
  PacketDispatcher as PacketDispatcher3c6u6w753k1f7,
  PacketHandler as PacketHandler113i5gse3aexx,
  AuthHandshakeRequest as AuthHandshakeRequest2cqt4ejyhdsww,
  AuthHandshakeResponse as AuthHandshakeResponsecnd8rs5it2d0,
  AuthStatusResponse as AuthStatusResponse2dgawm05ssn66,
  GameState as GameState3q77fz75jxadj,
  LoginRequest as LoginRequest33qo5tlvlqop3,
  MapChunkUpdatePacket as MapChunkUpdatePacketczpeqvhxthl7,
  MapDataPacket as MapDataPacket1xeubpx5tzkn3,
  MovePacket as MovePacket3tg8qd21dxvdk,
  RegisterRequest as RegisterRequest71c0d4m3i6t,
};
//endregion
